/**
 * Filtros de `referencia_tipo` aceitos neste projeto.
 *
 * Por que esse arquivo existe:
 * O endpoint /historico-eventos do backend aceita o parâmetro
 * `referencia_tipo` mas, na ausência dele, devolve registros de TODOS
 * os módulos que compartilham a tabela (incluindo o Cadastro Empresa).
 *
 * Para o card "Impedir que informações do projeto Cadastro Empresa
 * sejam apresentadas indevidamente no histórico deste projeto", o
 * frontend aplica **apenas filtragem client-side** por lista branca:
 * se o backend mandar um item com `referencia_tipo` fora da lista,
 * descartamos antes de exibir.
 *
 * OBS: removemos o envio de `referencia_tipo` na query string em
 * 2026-09-25. Alguns backends rejeitam a chave duplicada (`400 Bad
 * Request`) quando recebem `?referencia_tipo=tca&referencia_tipo=tca_empregador`
 * — a defesa em profundidade via lista branca client-side é
 * suficiente para impedir o vazamento do módulo "cadastro_empresa".
 *
 * Lista branca alinhada com o que este projeto (autorização de estágio
 * aprendiz) manipula:
 *   - tce             → TCE (programa 0)
 *   - tca             → TCA padrão (programa 1)
 *   - tca_empregador  → TCA Empregador (programa 2)
 *
 * Cadastro Empresa (módulo-irmão) usa "cadastro_empresa" e portanto
 * fica de fora automaticamente.
 */

export const REFERENCIAS_ACEITAS = ["tce", "tca", "tca_empregador"];

/**
 * Testa se um item deve ser exibido no histórico deste projeto.
 *
 * @param {object} item - Item bruto retornado pelo backend
 * @returns {boolean} true se o item é de um módulo aceito, false caso contrário
 */
export function ehReferenciaValida(item) {
  if (!item || typeof item !== "object") return false;
  const ref = String(item.referencia_tipo || "")
    .trim()
    .toLowerCase();
  if (!ref) return true; // Sem referencia_tipo → aceita (legado / fallback)
  return REFERENCIAS_ACEITAS.includes(ref);
}

/**
 * No-op mantido por compatibilidade com o import no index.js.
 *
 * ANTES (até 2026-09-25): essa função anexava múltiplos
 * `referencia_tipo` na query string — alguns backends rejeitam
 * chave duplicada com `400 Bad Request`, então passamos a depender
 * **apenas** da filtragem client-side em `ehReferenciaValida`.
 *
 * A função agora retorna `params` intacto, sem anexar nada. Mantida
 * como no-op para evitar refactor de imports fora deste modulo.
 */
export function anexarReferenciasAceitas(params) {
  return params;
}

/**
 * Helper de filter() pronto pra uso em Array.prototype.filter.
 */
export function filtrarPorReferenciaValida(item) {
  return ehReferenciaValida(item);
}
